import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const TawkLoader = () => {
  const location = useLocation();

  useEffect(() => {
    // List of paths where you WANT the widget to appear
    const allowedPaths = ["/card", "/home", "/people"];

    // Check if current path is allowed AND screen width is desktop
    const shouldShowWidget =
      window.innerWidth > 768 && allowedPaths.includes(location.pathname);

    if (shouldShowWidget) {
      const existingScript = document.getElementById("tawk-script");

      if (!existingScript) {
        const s1 = document.createElement("script");
        s1.async = true;
        s1.src = "https://embed.tawk.to/67e00be04c28fa190fcd2327/1in1ispko";
        s1.charset = "UTF-8";
        s1.setAttribute("crossorigin", "*");
        s1.id = "tawk-script";
        document.body.appendChild(s1);
      }

      // Show the widget if Tawk.to is already loaded
      if (window.Tawk_API?.showWidget) {
        window.Tawk_API.showWidget();
      }
    } else {
      // Hide the widget if not on an allowed path or on mobile
      if (window.Tawk_API?.hideWidget) {
        window.Tawk_API.hideWidget();
      }
    }
  }, [location]);

  return null;
};

export default TawkLoader;
